<template>
  <div
    class="custom-swiper-wrap p-top-6 p-bot-8"
    :class="item?.mostraBottoneCarosello?.[0] ? '' : 'no-cta'"
  >
    <div v-if="item" class="show-for-large">
      <WidgetSliderSwiper
        class="custom-swiper"
        :length="item.slide.length"
        :title="props.title"
        :text="props.text"
        :bottoneCarosello="item?.mostraBottoneCarosello?.[0]"
        type="custom-text-position"
      >
        <template
          v-for="(slide, index) in item.slide"
          :key="index"
          #[`slide-${index}`]
        >
          <CustomSwiperSlide :item="slide" />
        </template>
      </WidgetSliderSwiper>
    </div>
    <div v-if="item" class="hide-for-large">
      <div class="row-1 intro-title">
        <div
          v-if="props.title"
          class="custom-swiper__title title-big3 is-medium-bold m-bot-10"
          v-html="props.title"
        />
        <div
          v-if="props.text"
          class="custom-swiper__text title-base m-bot-11"
          v-html="props.text"
        />
      </div>
      <div class="mobile-section-wrap">
        <div
          v-for="(slide, index) in item.slide"
          :key="index"
          class="mobile-section"
        >
          <div v-if="slide.portrait.length" class="mobile-section__image">
            <WidgetPicture
              :image="{
                custom: slide.portrait?.[0],
              }"
              :alt="slide.portrait?.[0]?.title"
            />
          </div>
          <div class="mobile-section__text">
            <div
              v-if="slide?.sectionTitle"
              class="mobile-section__title text-medium4"
            >
              <div v-html="slide.sectionTitle" />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="item.mostraBottoneCarosello && item.mostraBottoneCarosello.length"
        class="m-top-8 flex --justify-start hide-for-large row-1"
      >
        <nuxt-link
          class="round-icon-btn"
          :to="localePath(item.mostraBottoneCarosello[0].linkDefault)"
        >
          <span
            class="text-medium5 is-medium-bold"
            v-html="item.mostraBottoneCarosello[0].label"
          />
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  title: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
})
</script>

<script>
export default {
  name: 'CustomSwiper',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
